import React from "react"
import { Box } from "@chakra-ui/react"
import { useAnimation } from "framer-motion"

import Projection from "./Projection"
import Defs from "./Defs"
import Base from "./Base"

export function Controller(props) {
  const controls = useAnimation()

  const startMainSequence = async () => {
    await controls.start(["droneR1", "droneX1", "droneY1"])

    await controls.start("step1Start")
    await controls.start("step1End")

    await controls.start(["droneR2", "droneX2", "droneY2"])

    await controls.start("step2Start")
    await controls.start("step2End")

    await controls.start(["droneR3", "droneX3", "droneY3"])

    await controls.start("step3Start")
    await controls.start("step3End")

    startMainSequence()
  }

  setTimeout(() => {
    controls.start("droneStart")
    startMainSequence()
  }, 500)

  return (
    <Box
      as="svg"
      viewBox="0 0 450 550"
      mr="auto"
      ml={{ base: "auto", lg: 0 }}
      {...props}
    >
      <Defs />
      <rect fill="#111C2C" width={450} height={500} />
      <Projection controls={controls} />
      <Base />
    </Box>
  )
}
